import { c as _c } from "react/compiler-runtime";
import { Grid } from "@chakra-ui/react";
import { useIntl } from "react-intl";
import { ColorToggle } from "../ColorToggle";
import { FilterContainer } from "../FilterContainer";
import { TrajectoryPointDtoVehicleType } from "@/api/generated/models/trajectoryPointDtoVehicleType";
import { vehicleTypeColors } from "@/styles/theme";
import { vehicleTypeLabels } from "@/utils/vehicleTypeUtils";
export interface VehicleTypeFilterProps {
  selectedVehicleTypes: TrajectoryPointDtoVehicleType[];
  setSelectedVehicleTypes: (types: TrajectoryPointDtoVehicleType[]) => void;
  availableVehicleTypes?: TrajectoryPointDtoVehicleType[];
}
export const VehicleTypeFilter = t0 => {
  const $ = _c(21);
  const {
    selectedVehicleTypes,
    setSelectedVehicleTypes,
    availableVehicleTypes
  } = t0;
  const intl = useIntl();
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== availableVehicleTypes || $[1] !== intl || $[2] !== selectedVehicleTypes || $[3] !== setSelectedVehicleTypes) {
    const allVehicleTypes = Object.values(TrajectoryPointDtoVehicleType);
    const handleToggle = vehicleType => {
      if (selectedVehicleTypes.includes(vehicleType)) {
        setSelectedVehicleTypes(selectedVehicleTypes.filter(t => t !== vehicleType));
        return;
      }
      setSelectedVehicleTypes([...selectedVehicleTypes, vehicleType]);
    };
    T1 = FilterContainer;
    t4 = "vehicle-type-filter";
    t5 = "600px";
    T0 = Grid;
    t1 = "repeat(auto-fit, minmax(150px, 1fr))";
    t2 = "8";
    t3 = allVehicleTypes.map(vehicleType_0 => {
      const isAvailable = !availableVehicleTypes || availableVehicleTypes.includes(vehicleType_0);
      return <ColorToggle key={vehicleType_0} color={vehicleTypeColors[vehicleType_0]} checked={selectedVehicleTypes.includes(vehicleType_0)} onToggle={() => handleToggle(vehicleType_0)} label={intl.formatMessage(vehicleTypeLabels[vehicleType_0])} disabled={!isAvailable} data-testid={`toggle-${vehicleType_0}`} />;
    });
    $[0] = availableVehicleTypes;
    $[1] = intl;
    $[2] = selectedVehicleTypes;
    $[3] = setSelectedVehicleTypes;
    $[4] = T0;
    $[5] = T1;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    T0 = $[4];
    T1 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[11] !== T0 || $[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t6 = <T0 templateColumns={t1} gap={t2}>{t3}</T0>;
    $[11] = T0;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== T1 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6) {
    t7 = <T1 data-testid={t4} maxWidth={t5}>{t6}</T1>;
    $[16] = T1;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};